import { useState } from "react";
function useFlashModal() {
  const [isOpen, setIsOpen] = useState(!1);
  function open() {
    setIsOpen(!0);
  }
  function close() {
    setIsOpen(!1);
  }
  function toggle() {
    setIsOpen((prev) => !prev);
  }
  return { isOpen, open, close, toggle };
}
export {
  useFlashModal
};
//# sourceMappingURL=useFlashModal.js.map
